"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepIndex = void 0;
var StepIndex;
(function (StepIndex) {
    StepIndex[StepIndex["CREATE_ACCOUNT_INDEX"] = 0] = "CREATE_ACCOUNT_INDEX";
    StepIndex[StepIndex["SIGN_MNDA_INDEX"] = 1] = "SIGN_MNDA_INDEX";
    StepIndex[StepIndex["BUILD_DATAROOM_INDEX"] = 2] = "BUILD_DATAROOM_INDEX";
})(StepIndex = exports.StepIndex || (exports.StepIndex = {}));
//# sourceMappingURL=enums.js.map